import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { memo } from 'react';
import { InlinedImage } from '../inlinedImage/inlinedImage';
/** Takes inline images as object and renders them as {@link InlinedImage} */
export const InlinedImages = memo(function InlinedImages({ files, }) {
    return (_jsxs(_Fragment, { children: [_jsx("hr", {}), _jsx(FlexBox, Object.assign({ gap: "200", flexWrap: "wrap", alignItems: "stretch" }, { children: files.map((file, index) => (_jsx("div", { children: _jsx(InlinedImage, { number: index, src: file.url, alt: file.pretty_name, attachedFileFallback: true }) }, file.url))) }))] }));
});
